import Vue from 'vue'
import App from './App.vue'
import router from './router' // 引入上面写好的路由文件

// 引入 Vant 组件库和样式
import Vant from 'vant'
import 'vant/lib/index.css'

// 全局使用 Vant
Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
